import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../Model/Common/common.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-leave-closing-detail',
  standalone: true,
  imports: [DataTablesModule, CommonModule, NgSelectModule, FormsModule],
  templateUrl: './leave-closing-detail.component.html',
  styleUrl: './leave-closing-detail.component.scss'
})
export class LeaveClosingDetailComponent {

  @Input() data = [] as any
  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Actions = [{label: 'No Action', value: 'No Action'}, {label: 'Addition', value: 'Addition'}, {label: 'Reduction', value: 'Reduction'}]

  constructor(
    private activeModal: NgbActiveModal,
    public common: CommonService
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.data.forEach((e: any) => {
      e.action = 'No Action',
      e.count = 0
    });
    console.log(this.data);
  }

  close() {
    this.activeModal.close();
  }

}
